import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import RadioBar from "@/components/RadioBar";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Magazine from "@/pages/Magazine";
import ArticleDetail from "@/pages/ArticleDetail";
import Directory from "@/pages/Directory";
import ProfileDetail from "@/pages/ProfileDetail";
import Events from "@/pages/Events";
import Press from "@/pages/Press";
import FilmPage from "@/pages/FilmPage";
import Submit from "@/pages/Submit";
import Contact from "@/pages/Contact";
import Pricing from "@/pages/Pricing";
import PricingSuccess from "@/pages/PricingSuccess";
import Services from "@/pages/Services";
import MusicVideos from "@/pages/MusicVideos";
import RadioStation from "@/pages/RadioStation";
import Community from "@/pages/Community";
import CommunityJoin from "@/pages/CommunityJoin";
import Feed from "@/pages/Feed";
import Messages from "@/pages/Messages";
import Casino from "@/pages/Casino";
import Giveaway from "@/pages/Giveaway";
import Marketplace from "@/pages/Marketplace";
import MarketplaceProduct from "@/pages/MarketplaceProduct";
import VendorStorefront from "@/pages/VendorStorefront";
import VendorRegister from "@/pages/VendorRegister";
import VendorDashboard from "@/pages/VendorDashboard";
import VendorSuccess from "@/pages/VendorSuccess";
import MarketplaceOrderSuccess from "@/pages/MarketplaceOrderSuccess";
import LiveNow from "@/pages/LiveNow";
import Jobs from "@/pages/Jobs";
import InstallPWAPrompt from "@/components/InstallPWAPrompt";
import DailyBonusToast from "@/components/DailyBonusToast";
import NewsletterConfirm from "@/pages/NewsletterConfirm";
import NewsletterUnsubscribe from "@/pages/NewsletterUnsubscribe";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import AuthCallback from "@/pages/AuthCallback";

function AppShell() {
  const location = useLocation();

  useEffect(() => {
    document.title = "Public Figures Campaign — Promoting Talent. Elevating Brands. Inspiring the World.";
  }, []);

  // Handle Google OAuth callback synchronously before routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="App font-body">
      <Header />
      <RadioBar />
      <DailyBonusToast />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/magazine" element={<Magazine />} />
          <Route path="/magazine/:slug" element={<ArticleDetail />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/profile/:id" element={<ProfileDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/press" element={<Press />} />
          <Route path="/film" element={<FilmPage />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/pricing/success" element={<PricingSuccess />} />
          <Route path="/services" element={<Services />} />
          <Route path="/music-videos" element={<MusicVideos />} />
          <Route path="/radio" element={<RadioStation />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/join" element={<CommunityJoin />} />
          <Route path="/feed" element={<Feed />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/messages/:otherUserId" element={<Messages />} />
          <Route path="/casino" element={<Casino />} />
          <Route path="/giveaway" element={<Giveaway />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/marketplace/product/:productId" element={<MarketplaceProduct />} />
          <Route path="/marketplace/vendor/:slug" element={<VendorStorefront />} />
          <Route path="/marketplace/order-success" element={<MarketplaceOrderSuccess />} />
          <Route path="/live" element={<LiveNow />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/vendor/register" element={<VendorRegister />} />
          <Route path="/vendor/dashboard" element={<VendorDashboard />} />
          <Route path="/vendor/success" element={<VendorSuccess />} />
          <Route path="/newsletter/confirm/:token" element={<NewsletterConfirm />} />
          <Route path="/newsletter/unsubscribe/:token" element={<NewsletterUnsubscribe />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <InstallPWAPrompt />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors closeButton />
        <AppShell />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
